import Image from 'next/image';
import PromptContainer from '@/components/elements/PromptContainer/PromptContainer';
import Close from '@/components/elements/Close/Close';
import styles from './ShirtPrompt.module.scss';

const ShirtPrompt = ({close, show}) => {


    return ( 
        <PromptContainer close={close} show={show}>
            <div className={`${styles.shirtPrompt}`}>
                <div className={styles.shirtPrompt__exit}>
                    <Close size="sm" close={close} />
                </div>
                <div className={styles.shirtPrompt__shirt}>
                    <Image src="/shirt.png" alt="afterglow shirt" priority={true} width={240} height={400}  />
                </div>
            </div>
        </PromptContainer>
     );
}
 
export default ShirtPrompt;